import { LegalLayout, H2, P, Ul, Li, A } from "./LegalLayout.jsx";
import { SUPPORT_EMAIL } from "../contact.js";

export default function TermsPage() {
  return (
    <LegalLayout title="Terms & Conditions" lastUpdated="22 October 2026">

      <P>Please read these terms before using NomLoop. By creating an account or
      using the service you agree to them.</P>

      <H2>1. About NomLoop</H2>
      <P>NomLoop is a meal planning tool that helps you choose recipes, plan around
      shared ingredients, and build a grocery shopping list. NomLoop does not
      currently earn affiliate commissions; section 5 explains what would apply if
      that changes.</P>

      <H2>2. Eligibility</H2>
      <P>You must be 18 or older and resident in the United Kingdom to use NomLoop.
      By using the service you confirm this.</P>

      <H2>3. Your account</H2>
      <Ul>
        <Li>You are responsible for keeping your sign-in email address accurate.</Li>
        <Li>You must not share your account or use it for commercial purposes without
        our written permission.</Li>
        <Li>We may suspend or delete accounts that violate these terms.</Li>
      </Ul>

      <H2>4. The service</H2>
      <Ul>
        <Li>Meal plans, ingredient lists, and cost estimates are generated
        algorithmically. They are <strong>indicative only</strong> — actual grocery
        prices may differ from those shown.</Li>
        <Li>Allergen and dietary filters reduce but do not eliminate risk. Always
        read product labels before purchasing.</Li>
        <Li>We are not responsible for the content, availability, or pricing of
        any third-party retailer website.</Li>
        <Li>NomLoop is provided "as is". We do not guarantee uninterrupted access.</Li>
      </Ul>

      <H2>5. Affiliate relationships</H2>
      <P>NomLoop does not currently take part in any affiliate programme. If we add
      affiliate grocery links in future, we will disclose them at the link, any
      commission will come from the retailer at no extra cost to you, and we will
      follow the UK CAP Code on affiliate disclosure.</P>

      <H2>6. Intellectual property</H2>
      <P>The NomLoop brand, user interface, and all server-side algorithms are our
      intellectual property. You may not copy, reverse-engineer, or redistribute
      any part of the service. Meal names and descriptions are editorial — they do
      not constitute recipes and are not covered by third-party copyright.</P>

      <H2>7. User-imported content</H2>
      <P>NomLoop lets you import recipes from external URLs for your personal meal
      planning. By using this feature you agree to the following:</P>
      <Ul>
        <Li><strong>Personal use only.</strong> You may only import content for
        your own private meal planning. You must not use the import feature to
        reproduce or redistribute third-party recipes at scale.</Li>
        <Li><strong>Your responsibility.</strong> You are solely responsible for
        ensuring you have the right to access and use any content you import.
        NomLoop is not liable for any copyright infringement arising from content
        you choose to import.</Li>
        <Li><strong>Private by default.</strong> Imported recipes are stored
        privately and are never visible to other users or indexed publicly by
        NomLoop.</Li>
        <Li><strong>Source attribution.</strong> We display the original source
        URL alongside any imported recipe so you can return to the creator's site.
        You should respect the original creator's own terms of use.</Li>
        <Li><strong>Retention and deletion.</strong> Imported recipe data is
        retained as described in our Privacy Policy. You may delete your imported
        recipes at any time from your account settings.</Li>
      </Ul>

      <H2>8. Limitation of liability</H2>
      <P>To the maximum extent permitted by UK law, NomLoop's total liability for
      any claim arising from use of the service is limited to £50. We are not
      liable for indirect or consequential losses, including any financial loss
      arising from grocery purchases made through the service.</P>

      <H2>9. Governing law</H2>
      <P>These terms are governed by the laws of England and Wales. Disputes will
      be subject to the exclusive jurisdiction of the courts of England and Wales.</P>

      <H2>10. Changes to these terms</H2>
      <P>We'll notify signed-in users by email of material changes at least 14 days
      before they take effect. Continued use of the service after that date
      constitutes acceptance.</P>

      <H2>11. Contact</H2>
      <P>{SUPPORT_EMAIL
        ? <>Questions? Email <A href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</A>.</>
        : "Questions? Use the contact route shown in the NomLoop app (Settings)."}</P>

    </LegalLayout>
  );
}
